import moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// UI

import DownloadButton from '@/components/Elements/Button/DownloadButton'
import ViewFileButton from '@/components/Elements/Button/ViewFileButton'
import {
  Box,
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
// Custom

import { setFileHistoryModal } from '@/stores/ui/uiSlice'

import EditableTable from '@/components/Table/EditableTable'
import { createColumnHelper } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

const FileHistoryModal = () => {
  // Redux

  const { show, title, files } = useSelector((state) => state.ui.fileHistoryModal)
  const { t } = useTranslation()

  // Local
  const [data, setData] = useState([])

  // Hooks
  const dispatch = useDispatch()
  const columnHelper = createColumnHelper()

  const columnDef = useMemo(
    () => [
      columnHelper.accessor('createdAt', {
        header: () => <span> {t('FILE_HISTORY_MODAL_UPLOAD_DATE')}</span>,
      }),

      columnHelper.accessor('createdBy', {
        header: () => <span> {t('FILE_HISTORY_MODAL_UPLOAD_BY')}</span>,
      }),

      columnHelper.accessor('originalFileName', {
        header: () => <span> {t('FILE_HISTORY_MODAL_FILE_NAME')}</span>,
      }),

      columnHelper.accessor('fileId', {
        header: () => <span></span>,
        cell: ({ getValue, row: { original } }) => (
          <HStack>
            {original.originalFileName.includes('.pdf') && <ViewFileButton fileId={getValue()} />}
            <DownloadButton fileId={getValue()} fileName={original.originalFileName} />
          </HStack>
        ),
      }),
    ],
    []
  )

  const transformFilesData = (documents) => {
    if (!Array.isArray(documents)) {
      return []
    }
    return documents.map((doc) => ({
      version: doc.version,
      createdAt: moment(doc.createdAt).format('DD-MMM-YYYY'),
      createdBy: doc.createdBy?.fullName || '',
      fileId: doc._id,
      originalFileName: doc.originalFileName,
    }))
  }

  useEffect(() => {
    if (show) {
      setData(transformFilesData(files))
    }
  }, [show, files])

  // Handler

  const closeModal = () => {
    dispatch(
      setFileHistoryModal({
        show: false,
        files: [],
      })
    )
  }

  const onSubmit = (e) => {
    e.preventDefault()
  }

  return (
    <Modal isOpen={show} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent maxW="1000px">
        <form onSubmit={onSubmit}>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box w="100%">
              <EditableTable columnDef={columnDef} data={show ? data : []} disabled={true} tableWidth="100%" />
            </Box>
          </ModalBody>

          <ModalFooter>
            <Flex w="100%">
              <Button colorScheme="gray" onClick={closeModal}>
                {t('FILE_HISTORY_MODAL_CLOSE')}
              </Button>
            </Flex>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  )
}

export default FileHistoryModal
